import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

const MUSIC_FAQ = [
  {
    title: 'Что делает Boostclick?',
    isH3: false,
    text:
      <p>
        Boostclick — это платформа, где где вы размещаете задания для слушателей.
        <br />
        Пользователи добровольно переходят к вашему треку в Яндекс.Музыке, слушают его и при желании выполняют действия: лайк, добавление, переход к артисту. После этого они заполняют мини-отчет — это обратная связь, которую вы можете использовать для оценки восприятия.
      </p>
  },
  {
    title: 'Кто выполняет задания?',
    isH3: false,
    text:
      <p>
        Реальные пользователи из России с аккаунтами Яндекса. Они читают инструкцию, запускают ваш трек и дают обратную связь через форму отчета. Вы можете задать, какие действия ожидаются (прослушивание, переходы и т.д.), но итоговое выполнение зависит от пользователя.
      </p>
  },
  {
    title: 'Какие действия может выполнить слушатель?',
    isH3: false,
    text:
      <div>
        Вы можете предложить слушателям:
        <br />
        <ul>
          <li>Перейти по ссылке на ваш трек или альбом</li>
          <li>Послушать часть трека (например, 1–3 минуты)</li>
          <li>При желании — лайкнуть, добавить в «Мои треки»</li>
          <li>Перейти к альбому или странице исполнителя</li>
          <li>Ответить на контрольный вопрос (например: «Какой жанр трека?»)</li>
        </ul>
      </div>
  },
  {
    title: 'Помогает ли это продвижению?',
    isH3: false,
    text:
      <p>
        Boostclick не гарантирует результатов в чартах или алгоритмах.
        Но вовлеченность реальных слушателей, естественное прослушивание и обратная связь могут быть полезны для понимания интереса аудитории и потенциально влиять на поведенческие сигналы.
      </p>
  },
  {
    title: 'Это подходит для альбомов?',
    isH3: false,
    text:
      <p>
        Да. Вы можете продвигать плейлисты, синглы или альбомы. Укажите ссылку и действия, которые важно протестировать: сколько треков слушают, что запоминается, и т.д.
      </p>
  },
  {
    title: 'Что включено в отчет?',
    isH3: false,
    text:
    <div>
        Вы получаете:
        <br />
        <ul>
          <li>Подтверждение выполнения задания</li>
          <li>Ответ на контрольный вопрос</li>
          <li>Краткий комментарий слушателя (если включено)</li>
        </ul>
      </div>
  },
];

const YA_MUSIC_PRODVIZHENIE_ARTICLE = {
  title: 'Продвижение треков в Яндекс Музыке* в 2026 году',
  content: <div>
    Продвинуть песню в Яндекс Музыке* стало не так просто, как пару лет назад. Алгоритмы стали умнее: они отслеживают, кто реально слушает трек, как долго держат внимание, добавляют ли в плейлисты и возвращаются ли потом. Просто залить песню и ждать буста — не вариант.
    <br />
    <br />
    Теперь важно понимать, как система видит слушателя. Если человек включает трек, но быстро переключает, платформа понимает — не зашло. А если дослушал до конца, переслушал, поделился — это уже сигнал, что музыка живая и интересная. На таких данных и строится весь рейтинг.
    <br />
    <br />
    <h3>Что реально работает в 2026 году</h3>
    <br />
    <ul>
      <li>Активное начало. Первые 10 секунд решают всё. Алгоритмы Яндекс Музыки* измеряют удержание — если человек уходит в этот момент, трек падает в рекомендациях.</li>
      <li>Честная аудитория. Закупка “пустых” прослушиваний уже не помогает. Важно, чтобы слушатели были реальными и проявляли активность — ставили лайки, добавляли в плейлисты, возвращались к исполнителю.</li>
      <li>Сценарии прослушивания. Хорошо, если трек попадает в разные плейлисты: утренние, рабочие, вечерние. Алгоритм видит контекст, где музыка звучит, и продвигает её тем, кому подходит настроение.</li>
      <li>Работа с описанием и обложкой. Да, это тоже влияет. Если обложка зацепила, CTR выше, значит, больше первых прослушиваний.</li>
      <li>Динамика интереса. Алгоритм любит рост. Если каждый день трек набирает новых слушателей, он получает бонус в ранжировании.</li>
    </ul>
    <br />
    <h3>Что изменилось по сравнению с прошлыми годами</h3>
    <br />
    Раньше можно было залить трафик через массовые сервисы — сейчас это почти не работает. В 2026-м упор идёт на поведенческие сигналы: сколько трек живёт в фоне, сколько реальных людей возвращаются к нему через неделю, как реагируют пользователи похожих вкусов.
    <br />
    <br />
    Смотри, что важно: алгоритм не думает, он наблюдает. И если твоя музыка действительно вызывает эмоцию — он это увидит. Но если активность выглядит как «накрутка ради цифр», продвижение останавливается.
    <br />
    <br />
    <h3>Как подходить к продвижению</h3>
    <br />
    Думай не про цифры, а про поведение слушателей. Сделай первые 15 секунд цепляющими, поработай с описанием, собери реальную обратную связь. Можно использовать тестовые кампании — например, дать треку аудиторию через Boostclick, чтобы понять, где он «цепляет».
    <br />
    <br />
    Так что продвижение треков в 2026 году — это не гонка за прослушиваниями. Это способ показать музыку людям, которым она действительно может понравиться.
  </div>
};

const YA_MUSIC_PRESAVE_ARTICLE = {
  title: 'Продвижение альбомов через пресейв в Яндекс Музыке*',
  content: <div>
    Пресейв — это инструмент, который помогает артисту собрать первых слушателей ещё до выхода альбома. Когда человек нажимает «сохранить» трек или релиз заранее, он автоматически появляется в его медиатеке в день релиза. Так музыка получает стартовую волну прослушиваний и быстрее попадает в алгоритмы рекомендаций.
    <br />
    <br />
    В 2026 году пресейв стал одним из ключевых способов продвижения альбомов на стриминговых платформах. Он помогает не просто увеличить статистику в первый день, а показать Яндекс Музыке*, что релиза действительно ждут. Чем больше реальных сохранений и переходов по ссылке, тем выше вероятность попасть в подборки вроде «Новинки недели» или «Что слушают прямо сейчас».
    <br />
    <br />
    Продвижение через пресейв особенно эффективно, если артист заранее подогревает интерес — делится тизерами, обложкой, небольшими отрывками треков. Это создаёт естественный спрос, и тогда даже минимальная накрутка активности выглядит как нормальное поведение аудитории.
    <br />
    <br />
    Преимущество пресейва ещё и в том, что он помогает собрать базу активных слушателей. После релиза с ними можно работать напрямую — приглашать на концерты, анонсировать коллаборации, напоминать о новых треках.
    <br />
    <br />
    В отличие от обычной рекламы, где результат быстро исчезает, пресейв создаёт долгосрочный эффект. Один раз собранная аудитория остаётся с артистом надолго, а её вовлечённость влияет на рекомендации внутри сервиса.
    <br />
    <br />
    Так что если цель — не просто поднять цифры, а выстроить устойчивую аудиторию в Яндекс Музыке*, пресейв — безопасный и разумный шаг. Это мягкий способ продвижения, который показывает системе, что треками действительно интересуются живые слушатели.
  </div>
};

const YA_MUSIC_PROSLUSHKA_ARTICLE = {
  title: 'Накрутка прослушиваний в Яндекс Музыке*: стоит ли использовать в 2026 году',
  content: <div>
    В 2026 году продвижение музыки стало похоже на работу с алгоритмами соцсетей: важно не только количество прослушиваний, а то, как именно слушают трек. Яндекс Музыка* оценивает поведение пользователей — ставят ли лайки, добавляют ли в подборки, слушают ли песню до конца. Поэтому «накрутка прослушиваний» теперь должна быть максимально аккуратной.
    <br />
    <br />
    Если раньше хватало просто увеличить цифры в статистике, то сегодня важнее естественная динамика. Когда трек получает прослушивания с разных устройств, из разных городов и в разное время, система воспринимает это как реальную активность. А значит, песня может попасть в рекомендации или подборки дня, где её увидят новые слушатели.
    <br />
    <br />
    Использовать накрутку можно как вспомогательный инструмент — например, чтобы дать треку первый толчок или проверить, как аудитория реагирует на конкретный релиз. Но сам по себе этот метод не сделает песню популярной. Без качественного контента и регулярных публикаций эффект быстро исчезает.
    <br />
    <br />
    Опытные музыканты комбинируют методы продвижения: легкий прогрев через прослушивания, работа с обложками, коллаборации, размещения в плейлистах и сторис. Такой подход безопасен и естественно выглядит для алгоритмов Яндекс Музыки*.
    <br />
    <br />
    Главное — не гнаться за цифрами. Умные системы всё чаще оценивают вовлечение и интерес, а не просто количество запусков. Так что накрутка прослушиваний — не цель, а всего лишь инструмент, который помогает привлечь внимание к тому, что действительно стоит послушать.
  </div>
};

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого слушателя, и каждый сценарий начинается для нового слушателя с перехода на страницу по переданной вами ссылке.
</p>;

const ACTIONS = [
  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение Яндекс Музыка",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти продвигаемый трек",
    initialShare: 1,
  },
  {
    type: "ALWAYS.LISTEN",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Прослушать трек без перемотки",
    titleComment: "от 1 до 3 мин",
    initialShare: 1,
  },

  {
    type: "MAIN.FAVORITE_TRACK",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить трек в избранное",
    initialShare: 0.7,
    activityType: "Избранное",
  },
  {
    type: "MAIN.FAVORITE_ARTIST",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить исполнителя в избранное",
    initialShare: 0.3,
    activityType: "Избранное",
  },

  {
    type: "EXTRA.ARTIST",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Послушать другой трек исполнителя",
    initialShare: 0.4,
  },
  {
    type: "EXTRA.ALBUM",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Пролистать треки в альбоме",
    initialShare: 0.6,
  },
];

const ACTIONS_PRESAVES = [
  {
    type: "ALWAYS.LINK",
    icon: "open",
    iconHome: "home-open",
    title: "Перейти по ссылке на пресейв",
    initialShare: 1,
  },
  {
    type: "EXTRA.ARTIST",
    icon: "people",
    iconHome: "home-people",
    title: "Открыть профиль исполнителя",
    initialShare: 0.7,
  },
  {
    type: "EXTRA.TRACK",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Послушать другой трек исполнителя",
    initialShare: 0.3,
  },
  {
    type: "MAIN.PRESAVE",
    icon: "bell",
    iconHome: "home-bell",
    title: "Добавить трек/альбом в пресейв",
    initialShare: 1,
    activityType: "Пресейв",
  },
];

const ACTIONS_LISTENS = [
  {
    type: "VIEW.ARTIST",
    icon: "people",
    iconHome: "home-people",
    title: "Прослушка +\nоткрыть профиль исполнителя",
    titleComment: "без перемотки",
  },
  {
    type: "VIEW.LYRICS",
    icon: "open",
    iconHome: "home-open",
    title: "Прослушка +\nоткрыть текст песни",
    titleComment: "без перемотки",
  },
  {
    type: "VIEW.TRACK",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Прослушка +\nоткрыть другой трек исполнителя",
    titleComment: "без перемотки",
  },
].map(action => ({
  ...action,
  initialShare: 1 / 3,
  subactions: 2,
  itemTitle: 'прослушка',
}));

const CHAIN_PRICE = 25;
const CHAIN_STEPS = ACTIONS.filter(
  action => action.type.startsWith("ALWAYS.")
).length + 2;

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-heart",
    title: "Поставить лайк треку",
    titleComment: "Яндекс Музыка*",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-headphones",
    title: "Прослушать трек",
    titleComment: "от 1-3 минут",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-disk",
    title: "Перейти к альбому",
    titleComment: "от 30 сек",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-headphones",
    title: "Пролистать треки в альбоме",
    titleComment: "Яндекс Музыка*",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-track-artist",
    title: "Перейти к исполнителям",
    titleComment: "от 30 сек",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-headphones",
    title: "Послушать другой трек исполнителя",
    titleComment: "Яндекс Музыка*",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти продвигаемый трек",
    titleComment: "Яндекс Музыка*",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть",
    titleComment: "Яндекс Музыка*",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  },
  {
    iconHome: "home-add-track",
    title: "Добавить в плейлист / мои треки",
    path: "/prodvizhenie-trekov-yandexmusic",
    target: '_self',
  }
];

const YANDEXMUSIC_KEYWORDS = [
  'Я.Музыка', 'Яндекс Музыка', 'яндекс музыка', 'я.музыка', 'ЯМузыка', 'ямузыка'
];

class YandexMusicClass extends Market {
  id = 'yandexmusic';
  host = 'music.yandex.ru';
  hostsList = [];
  url = 'https://music.yandex.ru/';

  title = 'Я.Музыка';

  isMarketplace = false;
  isMusicPlatform = true;

  icon = "yandexmusic";
  titlePlaces = 'Я.Музыка';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 400 / 30;
  chainPrice = CHAIN_PRICE;
  chainsMin = 20;
  chainsMax = 400;

  chainsDefault = 30;
  reviewPrice = 0;
  chainsStep = 10;
  viewsStep = 50;

  viewPrice = 15;
  viewsMax = 1000;
  viewsPerDay = 100;

  keywords = YANDEXMUSIC_KEYWORDS;

  targetLinkComment = <span>Укажите ссылку на трек</span>;
  targetLinkCommentShort = <span>Укажите ссылку на трек</span>;

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      title: 'Активность',
      navigateTitle: 'Активность: прослушивания, лайки, вовлеченность',
      path: '/prodvizhenie-trekov-yandexmusic',
      rating: 0.10,
      icon: "headphones",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Продвижение треков в Яндекс Музыке — ЛЮДИ от ${CHAIN_PRICE / CHAIN_STEPS} руб.`,
        description: 'Слушатели Яндекс Музыки включают ваши треки, делятся и помогают оценить интерес аудитории.',
        canonical: '/prodvizhenie-trekov-yandexmusic',
      },
      intro: {
        title: 'Заказать продвижение треков в Яндекс Музыке*',
        comment: 'Через реальные прослушивания',
        points: [
          'Обратная связь от живых слушателей',
          'Естественные действия в Яндекс.Музыке*',
          'Тестирование треков и альбомов',
          'Повышение вовлеченности и интереса',
          'Без ботов',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта',
      stepPhrase2: 'Детали заданий для органического поиска слушателями',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Продвижение треков в Яндекс Музыке*',
      titleFAQ: "Вопрос-ответ: продвижение треков в Яндекс Музыке*",
      faq: MUSIC_FAQ,
      article: YA_MUSIC_PRODVIZHENIE_ARTICLE,
      actions: ACTIONS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый слушатель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем треке',
        'Скорость и сложность зависят от объема заданий и выбранных условий',
      ]
    },
    {
      id: MARKET_MODES.CHAINS,
      title: 'Пресейв',
      navigateTitle: 'Пресейв треков',
      path: '/prodvizhenie-trekov-yandexmusic-presave',
      rating: 0.10,
      icon: "headphones",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Пресейв альбома в Яндекс Музыке — ЛЮДИ от ${CHAIN_PRICE / CHAIN_STEPS} руб.`,
        description: 'Слушатели Яндекс Музыки добавляют в пресейв ваши треки, делятся и помогают оценить интерес аудитории',
        canonical: '/prodvizhenie-trekov-yandexmusic-presave',
      },
      intro: {
        title: 'Пресейв альбома в Яндекс Музыке*',
        comment: 'Через реальные прослушивания',
        points: [
          'Обратная связь от живых слушателей',
          'Естественные действия в Яндекс.Музыке*',
          'Тестирование треков и альбомов',
          'Повышение вовлеченности и интереса',
          'Без ботов',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта',
      stepPhrase2: 'Детали заданий для переходов и модерации',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать прейсейв альбома в Яндекс Музыке*',
      titleFAQ: "Вопрос-ответ: пресейв альбома в Яндекс Музыке*",
      faq: MUSIC_FAQ,
      article: YA_MUSIC_PRESAVE_ARTICLE,
      actions: ACTIONS_PRESAVES,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый слушатель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем треке',
        'Скорость и сложность зависят от объема заданий и выбранных условий',
      ]
    },
    {
      id: MARKET_MODES.VIEWS,
      title: 'Прослушка',
      navigateTitle: 'Прослушивание треков',
      path: '/prodvizhenie-trekov-yandexmusic-proslushka',
      rating: 0.10,
      icon: "headphones",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Прослушивание треков в Яндекс Музыке — ЛЮДИ от ${this.viewPrice} руб.`,
        description: 'Пользователи Яндекс Музыки слушают ваши треки, делятся и помогают оценить интерес аудитории',
        canonical: '/prodvizhenie-trekov-yandexmusic-proslushka',
      },
      intro: {
        title: 'Прослушивание треков в Яндекс Музыке*',
        comment: 'Реальными людьми и без перемотки',
        points: [
          'Обратная связь от живых слушателей',
          'Естественные действия в Яндекс.Музыке*',
          'Тестирование треков и альбомов',
          'Повышение вовлеченности и интереса',
          'Без ботов',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта',
      stepPhrase2: 'Детали заданий для переходов и модерации',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать прослушивание треков в Яндекс Музыке*',
      titleFAQ: "Вопрос-ответ: прослушивание треков в Яндекс Музыке*",
      faq: MUSIC_FAQ,
      article: YA_MUSIC_PROSLUSHKA_ARTICLE,
      actions: ACTIONS_LISTENS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый слушатель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем треке',
        'Скорость и сложность зависят от объема заданий и выбранных условий',
      ]
    },
  ];

  actionsMap = [...ACTIONS, ...ACTIONS_PRESAVES, ...ACTIONS_LISTENS].reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на трек';
  invalidUrlStr = 'Укажите корректную ссылку на трек';
}

const YandexMusic = new YandexMusicClass();
export default YandexMusic;
